/* ==========================================================================
   Omerspahic Atelier — Theme JS
   Warenkorb (Ajax), Varianten, Mengen, Mobilmenü, Suche, Reveal
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  var moneyFormat = window.themeMoneyFormat || '{{amount}}';

  /* --- Helfer ----------------------------------------------------------- */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    value = parts.join(',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  /* --- Body-Lock -------------------------------------------------------- */

  function lockBody(lock) {
    document.body.classList.toggle('is-locked', !!lock);
  }

  /* --- Warenkorb -------------------------------------------------------- */

  var Cart = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = qs('[data-cart-drawer]');
      this.overlay = qs('[data-cart-overlay]');
      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }
      var isDrawer = document.body.getAttribute('data-cart-type') !== 'page';
      if (isDrawer) {
        qsa('[data-cart-open]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (Cart.drawer) { e.preventDefault(); Cart.open(); }
          });
        });
      }
      qsa('[data-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', Cart.close.bind(Cart));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') Cart.close();
      });
      this.bindRemove();
      this.bindQuantity();
      this.refresh();
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      this.drawer.removeAttribute('aria-hidden');
      lockBody(true);
      var focusable = qs('button, a', this.drawer);
      if (focusable) focusable.focus();
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      lockBody(false);
    },

    refresh: function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); })
        .catch(function () {});
    },

    render: function (cart) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      var body = qs('[data-cart-body]');
      if (body && typeof cart.item_count === 'number') {
        if (cart.item_count === 0) {
          body.innerHTML =
            '<div class="cart-empty"><p>' +
            (window.themeStrings.empty || 'Dein Warenkorb ist leer') +
            '</p><a class="btn btn--outline" href="' +
            (window.themeStrings.allProducts || '/collections/all') +
            '">' + (window.themeStrings.continue || 'Weiter shoppen') + '</a></div>';
        } else {
          body.innerHTML = cart.items.map(Cart.lineMarkup).join('');
        }
        Cart.bindRemove();
        Cart.bindQuantity();
      }

      var total = qs('[data-cart-total]');
      if (total) total.textContent = formatMoney(cart.total_price);

      var sub = qs('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);

      Cart.renderShipBar(cart.total_price);
    },

    lineMarkup: function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
          '" alt="" loading="lazy" width="78" height="104">'
        : '<div class="card__placeholder"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
      return (
        '<div class="cart-line" data-line="' + item.key + '">' +
          '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<div class="cart-line__row">' +
              '<div class="qty" data-line-qty="' + item.key + '">' +
                '<button class="qty__btn" type="button" data-qty-down aria-label="' +
                  (window.themeStrings.decrease || 'Weniger') + '">&minus;</button>' +
                '<input class="qty__input" type="number" min="0" value="' + item.quantity +
                  '" data-qty-input aria-label="' + (window.themeStrings.quantity || 'Menge') + '">' +
                '<button class="qty__btn" type="button" data-qty-up aria-label="' +
                  (window.themeStrings.increase || 'Mehr') + '">+</button>' +
              '</div>' +
              '<span class="price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<div class="cart-line__row">' +
              '<button class="cart-line__remove" type="button" data-line-remove="' + item.key + '">' +
                (window.themeStrings.remove || 'Entfernen') + '</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    },

    renderShipBar: function (totalCents) {
      qsa('[data-ship-bar]').forEach(function (bar) {
        var threshold = parseFloat(bar.getAttribute('data-threshold')) * 100;
        if (!threshold) { bar.hidden = true; return; }
        bar.hidden = false;
        var remaining = Math.max(0, threshold - totalCents);
        var pct = Math.min(100, (totalCents / threshold) * 100);
        var label = qs('[data-ship-label]', bar);
        var fill = qs('[data-ship-fill]', bar);
        if (fill) fill.style.width = pct + '%';
        if (label) {
          label.textContent = remaining > 0
            ? (window.themeStrings.freeShipLeft || 'Noch %s bis Gratisversand')
                .replace('%s', formatMoney(remaining))
            : (window.themeStrings.freeShipReached || 'Gratisversand erreicht');
        }
      });
    },

    bindRemove: function () {
      qsa('[data-line-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          Cart.change(btn.getAttribute('data-line-remove'), 0);
        });
      });
    },

    bindQuantity: function () {
      qsa('[data-line-qty]').forEach(function (wrap) {
        var key = wrap.getAttribute('data-line-qty');
        var input = qs('[data-qty-input]', wrap);
        var up = qs('[data-qty-up]', wrap);
        var down = qs('[data-qty-down]', wrap);
        if (up) up.addEventListener('click', function () {
          Cart.change(key, (parseInt(input.value, 10) || 0) + 1);
        });
        if (down) down.addEventListener('click', function () {
          Cart.change(key, Math.max(0, (parseInt(input.value, 10) || 1) - 1));
        });
        if (input) input.addEventListener('change', function () {
          Cart.change(key, Math.max(0, parseInt(input.value, 10) || 0));
        });
      });
    },

    change: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.render(cart);
          if (window.Shopify && Shopify.onCartUpdate) Shopify.onCartUpdate(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () {});
    },

    add: function (body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    }
  };

  window.themeCart = Cart;

  /* --- Produktformular -------------------------------------------------- */

  function initProductForms() {
    qsa('[data-product-form]').forEach(function (form) {
      var section = form.closest('[data-product-section]') || document;
      var variantScript = qs('[data-variant-json]', section);
      if (!variantScript) return;

      var variants;
      try { variants = JSON.parse(variantScript.textContent); } catch (e) { return; }

      var idInput = qs('[data-variant-id]', form);
      var priceEl = qs('[data-product-price]', section);
      var compareEl = qs('[data-product-compare]', section);
      var stockEl = qs('[data-product-stock]', section);
      var submitBtn = qs('[data-add-button]', form);
      var mainImg = qs('[data-product-image]', section);

      function currentOptions() {
        return qsa('[data-option-index]', form).map(function (group) {
          var checked = qs('input:checked', group);
          return checked ? checked.value : null;
        });
      }

      function matchVariant() {
        var opts = currentOptions();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.options) continue;
          var same = v.options.every(function (val, idx) {
            return opts[idx] === undefined || opts[idx] === null || String(val) === String(opts[idx]);
          });
          if (same) return v;
        }
        return null;
      }

      function update() {
        var v = matchVariant();
        qsa('[data-option-index]', form).forEach(function (group, idx) {
          var chosen = currentOptions()[idx];
          qsa('.option-value', group).forEach(function (label) {
            var input = qs('input', label);
            var value = input ? input.value : null;
            label.classList.toggle('is-selected', value === chosen);
            var available = variants.some(function (vv) {
              if (String(vv.options[idx]) !== String(value)) return false;
              var opts = currentOptions();
              return vv.options.every(function (val, i2) {
                if (i2 === idx) return true;
                return opts[i2] === undefined || opts[i2] === null || String(val) === String(opts[i2]);
              });
            });
            label.classList.toggle('is-unavailable', !available);
          });
        });

        if (!v) {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = window.themeStrings.unavailable || 'Nicht verfügbar';
          }
          if (stockEl) {
            stockEl.className = 'stock-note stock-note--out';
            stockEl.textContent = window.themeStrings.outOfStock || 'Derzeit nicht verfügbar';
          }
          return;
        }

        if (idInput) idInput.value = v.id;

        if (priceEl) {
          priceEl.textContent = formatMoney(v.price);
          priceEl.classList.toggle('price__sale', v.compare_at_price > v.price);
        }
        if (compareEl) {
          compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
          compareEl.hidden = !(v.compare_at_price > v.price);
        }

        if (stockEl) {
          var out = v.available === false;
          stockEl.className = 'stock-note' + (out ? ' stock-note--out' : '');
          stockEl.textContent = out
            ? (window.themeStrings.outOfStock || 'Derzeit nicht verfügbar')
            : (v.inventory_quantity > 0 && v.inventory_quantity <= 5
                ? (window.themeStrings.lowStock || 'Nur noch wenige verfügbar')
                : (window.themeStrings.inStock || 'Auf Lager'));
        }

        if (submitBtn) {
          submitBtn.disabled = v.available === false;
          submitBtn.textContent = v.available === false
            ? (window.themeStrings.soldOut || 'Ausverkauft')
            : (window.themeStrings.addToCart || 'In den Warenkorb');
        }

        if (mainImg && v.featured_image && v.featured_image.src) {
          mainImg.src = v.featured_image.src;
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      form.addEventListener('change', function (e) {
        if (e.target.name && e.target.name.indexOf('options') === 0) update();
      });

      form.addEventListener('submit', function (e) {
        // Express-Checkout-Button nicht abfangen
        if (e.submitter && e.submitter !== submitBtn) { return; }
        e.preventDefault();
        var btn = submitBtn;
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = window.themeStrings.adding || 'Wird hinzugefügt …'; }

        var qtyInput = qs('[data-quantity-input]', form);
        var payload = {
          items: [{
            id: parseInt(idInput.value, 10),
            quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1
          }]
        };

        Cart.add(payload)
          .then(function () {
            if (btn) { btn.textContent = window.themeStrings.added || 'Hinzugefügt'; }
            var openDrawer = document.body.getAttribute('data-cart-type') !== 'page';
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                Cart.render(cart);
                if (openDrawer) Cart.open();
                else window.location.href = window.themeRoutes.cartUrl || '/cart';
              });
          })
          .then(function () {
            if (btn) {
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = btn.dataset.label || (window.themeStrings.addToCart || 'In den Warenkorb');
              }, 1400);
            }
          })
          .catch(function () {
            if (btn) {
              btn.disabled = false;
              btn.textContent = btn.dataset.label || (window.themeStrings.addToCart || 'In den Warenkorb');
            }
          });
      });

      update();
    });
  }

  /* --- Schnellkauf ------------------------------------------------------ */

  function initQuickAdd() {
    qsa('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-quick-add');
        if (!id) return;
        var label = btn.textContent;
        btn.textContent = window.themeStrings.adding || 'Wird hinzugefügt …';
        Cart.add({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
          .then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                Cart.render(cart);
                if (document.body.getAttribute('data-cart-type') !== 'page') Cart.open();
              });
          })
          .then(function () {
            btn.textContent = window.themeStrings.added || 'Hinzugefügt';
            setTimeout(function () { btn.textContent = label; }, 1400);
          })
          .catch(function () { btn.textContent = label; });
      });
    });
  }

  /* --- Galerie ---------------------------------------------------------- */

  function initGallery() {
    qsa('[data-gallery]').forEach(function (gallery) {
      var stage = qs('[data-product-image]', gallery);
      qsa('[data-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-thumb');
          if (stage && src) stage.src = src;
          qsa('[data-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* --- Mengenfelder ----------------------------------------------------- */

  function initQuantityInputs() {
    qsa('[data-qty-scope]').forEach(function (scope) {
      var input = qs('[data-quantity-input]', scope);
      if (!input) return;
      var up = qs('[data-qty-up]', scope);
      var down = qs('[data-qty-down]', scope);
      if (up) up.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
      if (down) down.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
    });
  }

  /* --- Mobilmenü -------------------------------------------------------- */

  function initMobileNav() {
    var toggle = qs('[data-nav-toggle]');
    var nav = qs('[data-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      lockBody(open);
    });
    qsa('a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        lockBody(false);
      });
    });
  }

  /* --- Suche ------------------------------------------------------------ */

  function initSearch() {
    var toggle = qs('[data-search-toggle]');
    var panel = qs('[data-search-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
        var input = qs('input[type="search"]', panel);
        if (input) input.focus();
      } else {
        panel.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* --- Reveal on Scroll -------------------------------------------------- */

  function initReveal() {
    var items = qsa('.reveal');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* --- Marquee (Duplikat sicherstellen) ---------------------------------- */

  function initMarquee() {
    qsa('[data-marquee]').forEach(function (marquee) {
      var track = qs('.marquee__track', marquee);
      if (!track) return;
      var group = qs('.marquee__group', track);
      if (group && track.children.length < 2) {
        track.appendChild(group.cloneNode(true));
      }
    });
  }

  /* --- Start ------------------------------------------------------------ */

  function boot() {
    Cart.init();
    initProductForms();
    initQuickAdd();
    initGallery();
    initQuantityInputs();
    initMobileNav();
    initSearch();
    initReveal();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
